import React, {useEffect, useState} from "react";
import axiosInstance from "../../../api/api";
import {Col, Form, Row, Table} from "@themesberg/react-bootstrap";
import DetailCompetitor from "../Demand/DetailCompetitor";
import CardLayout from "../Layout/CardLayout";
import EmpleadoTable from "./EmpleadoTable";
import Ranked from "../Ciem/Ranked";

const Empleado = (ciemId) => {
    const [rankedForm, setRankedForm] = useState([]);

    useEffect(() => {
        axiosInstance.get('/detailoption/option/value/rankedSix').then((response) => {
            console.log("Calificación obtenida:", response.data.data[0]);
            setRankedForm(response.data.data[0]);
        }).catch((e) => {
            alert("Error consultando la calificacion " + e)
        });
    }, []);

    const contributionForm =
           <EmpleadoTable ciemId={ciemId} tipoempleado={1}
                          nombreHeaderTabla={'empleadoTable'}
                          nombreHeaderTablatotales={'empleadoTotales'}
                          formEmpleado={'empleadoForm'}/>
    ;

    const calificacion = <Ranked field={rankedForm} ciemId={ciemId.ciemId} />

    return (
        <div className="container-fluid">
            <CardLayout value={"empleadoTitulo"} tablaComponent={contributionForm} />
            <CardLayout value={"rankedSix"} tablaComponent={calificacion} />
        </div>
    );
};

export default Empleado;